function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module link/linkediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import LinkCommand from './linkcommand';
import UnlinkCommand from './unlinkcommand';
import { createLinkElement, ensureSafeUrl, getLocalizedDecorators, normalizeDecorators } from './utils';
import AutomaticDecorators from './utils/automaticdecorators';
import ManualDecorator from './utils/manualdecorator';
import bindTwoStepCaretToAttribute from '@ckeditor/ckeditor5-engine/src/utils/bindtwostepcarettoattribute';
import findLinkRange from './findlinkrange';
import '../theme/link.css';
var HIGHLIGHT_CLASS = 'ck-link_selected';
var DECORATOR_AUTOMATIC = 'automatic';
var DECORATOR_MANUAL = 'manual';
var EXTERNAL_LINKS_REGEXP = /^(https?:)?\/\//;
/**
 * The link engine feature.
 *
 * It introduces the `linkHref="url"` attribute in the model which renders to the view as a `<a href="url">` element
 * as well as `'link'` and `'unlink'` commands.
 *
 * @extends module:core/plugin~Plugin
 */

var LinkEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(LinkEditing, _Plugin);

  var _super = _createSuper(LinkEditing);

  _createClass(LinkEditing, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'LinkEditing';
    }
    /**
     * @inheritDoc
     */

  }]);

  function LinkEditing(editor) {
    var _this;

    _classCallCheck(this, LinkEditing);

    _this = _super.call(this, editor);
    editor.config.define('link', {
      addTargetToExternalLinks: false
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(LinkEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var locale = editor.locale; // Allow link attribute on all inline nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: 'linkHref'
      });
      editor.conversion.for('dataDowncast').attributeToElement({
        model: 'linkHref',
        view: createLinkElement
      });
      editor.conversion.for('editingDowncast').attributeToElement({
        model: 'linkHref',
        view: function view(href, writer) {
          return createLinkElement(ensureSafeUrl(href), writer);
        }
      });
      editor.conversion.for('upcast').elementToAttribute({
        view: {
          name: 'a',
          attributes: {
            href: true
          }
        },
        model: {
          key: 'linkHref',
          value: function value(viewElement) {
            return viewElement.getAttribute('href');
          }
        }
      }); // Create linking commands.

      editor.commands.add('link', new LinkCommand(editor));
      editor.commands.add('unlink', new UnlinkCommand(editor));
      var linkDecorators = getLocalizedDecorators(editor.t, normalizeDecorators(editor.config.get('link.decorators')));

      this._enableAutomaticDecorators(linkDecorators.filter(function (item) {
        return item.mode === DECORATOR_AUTOMATIC;
      }));

      this._enableManualDecorators(linkDecorators.filter(function (item) {
        return item.mode === DECORATOR_MANUAL;
      })); // Enable two-step caret movement for `linkHref` attribute.


      bindTwoStepCaretToAttribute({
        view: editor.editing.view,
        model: editor.model,
        emitter: this,
        attribute: 'linkHref',
        locale: locale
      }); // Setup highlight over selected link.

      this._setupLinkHighlight();
    }
    /**
     * Processes an array of configured {@link module:link/link~LinkDecoratorAutomaticDefinition automatic decorators}
     * and registers a {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher downcast dispatcher}
     * for each one of them. Downcast dispatchers are obtained using the
     * {@link module:link/utils~AutomaticDecorators#getDispatcher} method.
     *
     * **Note**: This method also activates the automatic external link decorator if enabled with
     * {@link module:link/link~LinkConfig#addTargetToExternalLinks `config.link.addTargetToExternalLinks`}.
     *
     * @private
     * @param {Array.<module:link/link~LinkDecoratorAutomaticDefinition>} automaticDecoratorDefinitions
     */

  }, {
    key: "_enableAutomaticDecorators",
    value: function _enableAutomaticDecorators(automaticDecoratorDefinitions) {
      var editor = this.editor;
      var automaticDecorators = new AutomaticDecorators(); // Adds a default decorator for external links.

      if (editor.config.get('link.addTargetToExternalLinks')) {
        automaticDecorators.add({
          id: 'linkIsExternal',
          mode: DECORATOR_AUTOMATIC,
          callback: function callback(url) {
            return EXTERNAL_LINKS_REGEXP.test(url);
          },
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        });
      }

      automaticDecorators.add(automaticDecoratorDefinitions);

      if (automaticDecorators.length) {
        editor.conversion.for('downcast').add(automaticDecorators.getDispatcher());
      }
    }
    /**
     * Processes an array of configured {@link module:link/link~LinkDecoratorManualDefinition manual decorators},
     * transforms them into {@link module:link/utils~ManualDecorator} instances and stores them in the
     * {@link module:link/linkcommand~LinkCommand#manualDecorators} collection (a model for manual decorators state).
     *
     * Also registers an {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement attribute-to-element}
     * converter for each manual decorator and extends the {@link module:engine/model/schema~Schema model's schema}
     * with adequate model attributes.
     *
     * @private
     * @param {Array.<module:link/link~LinkDecoratorManualDefinition>} manualDecoratorDefinitions
     */

  }, {
    key: "_enableManualDecorators",
    value: function _enableManualDecorators(manualDecoratorDefinitions) {
      if (!manualDecoratorDefinitions.length) {
        return;
      }

      var editor = this.editor;
      var command = editor.commands.get('link');
      var manualDecorators = command.manualDecorators;
      manualDecoratorDefinitions.forEach(function (decorator) {
        editor.model.schema.extend('$text', {
          allowAttributes: decorator.id
        }); // Keeps reference to manual decorator to decode its name to attributes during downcast.

        manualDecorators.add(new ManualDecorator(decorator));
        editor.conversion.for('downcast').attributeToElement({
          model: decorator.id,
          view: function view(manualDecoratorName, writer) {
            if (manualDecoratorName) {
              var attributes = manualDecorators.get(decorator.id).attributes;
              var element = writer.createAttributeElement('a', attributes, {
                priority: 5
              });
              writer.setCustomProperty('link', true, element);
              return element;
            }
          }
        });
        editor.conversion.for('upcast').elementToAttribute({
          view: {
            name: 'a',
            attributes: manualDecorators.get(decorator.id).attributes
          },
          model: {
            key: decorator.id
          }
        });
      });
    }
    /**
     * Adds a visual highlight style to a link in which the selection is anchored.
     * Together with two-step caret movement, they indicate that the user is typing inside the link.
     *
     * Highlight is turned on by adding the `.ck-link_selected` class to the link in the view:
     *
     * * The class is removed before the conversion has started, as callbacks added with the `'highest'` priority
     * to {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher} events.
     * * The class is added in the view post fixer, after other changes in the model tree were converted to the view.
     *
     * This way, adding and removing the highlight does not interfere with conversion.
     *
     * @private
     */

  }, {
    key: "_setupLinkHighlight",
    value: function _setupLinkHighlight() {
      var editor = this.editor;
      var view = editor.editing.view;
      var highlightedLinks = new Set(); // Adding the class.

      view.document.registerPostFixer(function (writer) {
        var selection = editor.model.document.selection;
        var changed = false;

        if (selection.hasAttribute('linkHref')) {
          var modelRange = findLinkRange(selection.getFirstPosition(), selection.getAttribute('linkHref'), editor.model);
          var viewRange = editor.editing.mapper.toViewRange(modelRange); // There might be multiple `a` elements in the `viewRange`, for example, when the `a` element is
          // broken by a UIElement.

          var _iterator = _createForOfIteratorHelper(viewRange.getItems()),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;

              if (item.is('a') && !item.hasClass(HIGHLIGHT_CLASS)) {
                writer.addClass(HIGHLIGHT_CLASS, item);
                highlightedLinks.add(item);
                changed = true;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return changed;
      }); // Removing the class.

      editor.conversion.for('editingDowncast').add(function (dispatcher) {
        // Make sure the highlight is removed on every possible event, before conversion is started.
        dispatcher.on('insert', removeHighlight, {
          priority: 'highest'
        });
        dispatcher.on('remove', removeHighlight, {
          priority: 'highest'
        });
        dispatcher.on('attribute', removeHighlight, {
          priority: 'highest'
        });
        dispatcher.on('selection', removeHighlight, {
          priority: 'highest'
        });

        function removeHighlight() {
          view.change(function (writer) {
            var _iterator2 = _createForOfIteratorHelper(highlightedLinks.values()),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var item = _step2.value;
                writer.removeClass(HIGHLIGHT_CLASS, item);
                highlightedLinks.delete(item);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          });
        }
      });
    }
  }]);

  return LinkEditing;
}(Plugin);

export { LinkEditing as default };